/**
 * Integration with Polylang Pro.
 *
 * This file integrates the WordPress Polylang Pro plugin with the Qala Elastic Core framework.
 * It verifies if we are running Polylang Pro and if we need to dynamically add the current language to all queries to avoid showing all language content.
 */

/**
 * Retrieve the current Polylang language name from the global config.
 *
 * @return {string|null} The current language name, or null if unavailable.
 */
const getCurrentLanguage = () => {
	return window.QalaElasticCore?.polylang?.currentLanguage ?? null;
};

wp.hooks.addFilter(
	'qalaElasticCore.filter.headerSearch.query',
	'qalaElasticCore/polylang/headerSearchQuery',
	addLanguageToQuery,
	110
);

wp.hooks.addFilter(
	'qalaElasticCore.filter.query',
	'qalaElasticCore/polylang/query',
	addLanguageToQuery,
	110
);

/**
 * Add the current Polylang language to an Elasticsearch query.
 *
 * @param {Object} query - The App Search query object.
 * @return {Object} The modified query object with the language filter applied.
 */
function addLanguageToQuery( query ) {
	const currentLanguage = getCurrentLanguage();

	if ( ! currentLanguage ) {
		return query;
	}

	if ( ! query?.options?.filters?.all ) {
		query.options.filters.all = [];
	}

	query.options.filters.all.push( {
		language: currentLanguage,
	} );

	return query;
}
